import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { HistoricoChamado } from "../models/chamados/historico";
import { DefaultResponse } from "../models/DefaultResponse";

@Injectable({
    providedIn: 'root'
  })

  export class ConcluirService {
    private api = ConvivaApi;

    constructor(private http: HttpClient)
    { }

    public setCadastrarConcluir(parametros: HistoricoChamado):Observable<DefaultResponse> {
      return this.http.post<DefaultResponse>(`${this.api.Concluir.setCadastrarConcluir}`, parametros)
                      .pipe(map((response: DefaultResponse) => response));
    }

    public setCadastrarConcluirChamadoEnvolvidos(parametros: HistoricoChamado):Observable<DefaultResponse> {
      return this.http.post<DefaultResponse>(`${this.api.Concluir.setCadastrarConcluirChamadoEnvolvidos}`, parametros)
                      .pipe(map((response: DefaultResponse) => response));
    }

    public setCadastrarConcluirChamadoPorAtividade(parametros: HistoricoChamado):Observable<DefaultResponse> {
      return this.http.post<DefaultResponse>(`${this.api.Concluir.concluirChamadosPorAtividadePsicologo}`, parametros)
                      .pipe(map((response: DefaultResponse) => response));
    }

    public setCadastrarConcluirChamadoPorAtividadePOC(parametros: HistoricoChamado):Observable<DefaultResponse> {
      return this.http.post<DefaultResponse>(`${this.api.Concluir.concluirChamadosPorAtividadePOC}`, parametros)
                      .pipe(map((response: DefaultResponse) => response));
    }
}
